export const locales = {
  cn: () => import('@arco-design/web-vue/es/locale/lang/zh-cn'),
  en: () => import('@arco-design/web-vue/es/locale/lang/en-us'),
  ja: () => import('@arco-design/web-vue/es/locale/lang/ja-jp'),
  tw: () => import('@arco-design/web-vue/es/locale/lang/zh-tw'),
  pt: () => import('@arco-design/web-vue/es/locale/lang/pt-pt'),
  es: () => import('@arco-design/web-vue/es/locale/lang/es-es'),
  id: () => import('@arco-design/web-vue/es/locale/lang/id-id'),
  fr: () => import('@arco-design/web-vue/es/locale/lang/fr-fr'),
  de: () => import('@arco-design/web-vue/es/locale/lang/de-de'),
  ko: () => import('@arco-design/web-vue/es/locale/lang/ko-kr'),
  it: () => import('@arco-design/web-vue/es/locale/lang/it-it'),
  ms: () => import('@arco-design/web-vue/es/locale/lang/ms-my'),
  th: () => import('@arco-design/web-vue/es/locale/lang/th-th'),
  vi: () => import('@arco-design/web-vue/es/locale/lang/vi-vn'),
  km: () => import('@arco-design/web-vue/es/locale/lang/km-kh'),
  ar: () => import('@arco-design/web-vue/es/locale/lang/ar-eg'),
};
